import { z } from "zod";
import type { TrendyolStatus } from "./catalog-trendyol.js";

/** Katalog: eksik bilgi listesi (satışı ve Trendyol'a açmayı engelleyen ya da zayıflatan eksikler). */
export const COMPLETENESS_CHECKS = [
  { key: "image", label: "Görsel yok", hint: "Mağazada ve Trendyol'da en az bir görsel gerekir." },
  { key: "description", label: "Açıklama yok", hint: "Trendyol açıklamasız ürün kabul etmez." },
  { key: "brand", label: "Marka yok", hint: "Trendyol'da marka zorunludur; raporlarda markasız görünür." },
  { key: "barcode", label: "Barkod yok", hint: "Trendyol barkodla eşleştirir; yoksa stok kodu kullanılır." },
  { key: "attributes", label: "Saat özellikleri boş", hint: "Cinsiyet, mekanizma, kasa çapı … Trendyol özellik önerileri buradan gelir." },
  { key: "price", label: "Fiyat yok", hint: "IdeaSoft fiyatı olmayan ürün Trendyol'a açılamaz." },
  { key: "trendyol", label: "Trendyol'da yok", hint: "IdeaSoft'ta satışta, Trendyol'da açılmamış." },
  { key: "trendyol_problem", label: "Trendyol'da sorunlu", hint: "Trendyol reddetti ya da gönderilemedi." },
] as const;
export type CompletenessKey = (typeof COMPLETENESS_CHECKS)[number]["key"];
export const COMPLETENESS_KEYS = COMPLETENESS_CHECKS.map((c) => c.key) as [CompletenessKey, ...CompletenessKey[]];

export const completenessQuerySchema = z.object({
  missing: z.enum(["any", ...COMPLETENESS_KEYS]).default("any"),
  /** active: yalnız satıştakiler · all: tümü */
  scope: z.enum(["active", "all"]).default("active"),
  q: z.string().trim().max(120).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(10).max(100).default(25),
});
export type CompletenessQuery = z.infer<typeof completenessQuerySchema>;

export interface CompletenessRowDto {
  id: string;
  name: string;
  brand: string | null;
  sku: string | null;
  imageUrl: string | null;
  missing: CompletenessKey[];
  trendyolStatus: TrendyolStatus | null;
}

export interface CompletenessResponse {
  /** Kapsamdaki ürün sayısı (IdeaSoft ürünleri). */
  scopeTotal: number;
  /** Hiç eksiği olmayan ürün sayısı. */
  complete: number;
  /** IdeaSoft içeriği (açıklama, kategori, tüm görseller) panele henüz alınmamış ürün sayısı: bu ürünlerde açıklama / görsel eksiği gerçek olmayabilir. */
  unread: number;
  counts: Record<CompletenessKey, number>;
  /** Trendyol bağlı değilse Trendyol denetimleri yapılmaz. */
  trendyolConnected: boolean;
  items: CompletenessRowDto[];
  total: number;
  page: number;
  pageSize: number;
}
